import React, { useState, useEffect, useContext } from "react";
import { Label, Form, FormGroup, Row, Col, Input, InputGroup } from "reactstrap";
import { useController, useForm } from "react-hook-form";
import { CommonModal } from "../../AbstractElements";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import { createZone, getZoneDetailsById, updateZone } from "../../Services/Zone.service";
import { showAlert } from "../../Services/Shared.service";

const ZoneInput = ({ cityData, editId, setEditId, setIsOpen, fetchTableData, isOpen }) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset
    } = useForm({
        defaultValues: {
            serviceCity: "",
            area: "",
            zone: "",
            isAvailable: true,
        },
    });
    const values = getValues()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [zoneObj, setZoneObj] = useState({})
    const { mix_background_layout } = useContext(CustomizerContext)

    const serviceCityField = useController({
        name: "serviceCity",
        control,
        rules: {
            required: {
                value: true,
                message: "Service City is Required",
            },
        },
    }).field;

    const handleServiceCitySelectChange = (data) => {
        serviceCityField.onChange(data.value);
    };

    const isAvailableField = useController({
        name: "isAvailable",
        control,
    }).field;

    useEffect(() => {
        if (editId) {
            getZoneDetailsById(editId).then((resp) => {
                let zoneObj = resp.data
                setZoneObj(zoneObj)
                const serviceCity = cityData.find((element) => {
                    return element?.value?.id === zoneObj?.serviceCityId;
                })
                console.log("service city", serviceCity)
                reset({
                    serviceCity: serviceCity?.value?.id ? serviceCity?.value : "",
                    area: zoneObj.area ? zoneObj.area : "",
                    zone: zoneObj.zone ? zoneObj.zone : "",
                    isAvailable: zoneObj.isAvailable ? true : false,
                })
            }).catch((err) => {
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
            });
        }
    }, [editId])

    console.log("values", values)

    const onFormSubmit = (formValues) => {
        setIsSubmitting(true)
        const body = {
            serviceCityId: formValues.serviceCity?.id ? formValues.serviceCity.id : null,
            area: formValues.area,
            zone: formValues.zone,
            isAvailable: formValues.isAvailable,
            isDeleted: false
        };
        if (zoneObj.id) {
            body["id"] = zoneObj.id
            body["isDeleted"] = zoneObj.isDeleted
            updateZone(body)
                .then((result) => {
                    reset({
                        serviceCity: "",
                        area: "",
                        zone: "",
                        isAvailable: true,
                    })
                    showAlert("success", "Zone Updated Successfully");
                    fetchTableData();
                    setIsSubmitting(false)
                    setIsOpen(false)
                    setEditId("")
                    setZoneObj({})
                })
                .catch((err) => {
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                    setIsSubmitting(false)
                });
        } else {
            createZone(body)
                .then((result) => {
                    reset({
                        serviceCity: "",
                        area: "",
                        zone: "",
                        isAvailable: true,
                    })
                    showAlert("success", "Zone Created Successfully");
                    fetchTableData();
                    setIsSubmitting(false)
                    setIsOpen(false)
                    setEditId("")
                    setZoneObj({})
                })
                .catch((err) => {
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Cannot able to create zone for this service city");
                    setIsSubmitting(false)
                });
        }
    };

    return (
        <CommonModal
            isOpen={isOpen}
            title={editId ? "Edit Zone" : "Create Zone"}
            toggler={() => {
                reset({
                    serviceCity: "",
                    area: "",
                    zone: "",
                    isAvailable: true,
                })
                setIsOpen(!isOpen)
                setEditId("")
                setZoneObj({})
            }}
            size="xl"
        >
            <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Area</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("area", {
                                    required: {
                                        value: true,
                                        message: "Area is required",
                                    },
                                    onChange: (e) => {
                                        setValue("area", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.area?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Zone</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("zone", {
                                    required: {
                                        value: true,
                                        message: "Zone is required",
                                    },
                                    onChange: (e) => {
                                        setValue("zone", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.zone?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                        <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"} style={{ display: "flex", alignItems: "center" }}>
                            <Input
                                id="isAvailable"
                                type="checkbox"
                                checked={isAvailableField.value}
                                onChange={(value) => isAvailableField.onChange(value)}
                                disabled={zoneObj?.id ? false : true}
                            />
                            <Label className="mb-0" for="isAvailable" >{"Is Available"}</Label>
                        </div>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Service City</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <CustomSelect
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={serviceCityField?.value?.id ? cityData.find((element) => {
                                        return element?.value?.id === serviceCityField?.value?.id;
                                    }) : ""}
                                    isDisabled={zoneObj?.id ? true : false}
                                    // defaultValue={cityData.find((element) => {
                                    //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                                    //   return element?.value?.id === cityField?.value?.id;
                                    // })}
                                    onChange={handleServiceCitySelectChange}
                                    placeholder="Select City"
                                    options={cityData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.serviceCity?.message}</span>
                        </Col>
                    </FormGroup>
                </Row>


                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" className="btn submit-button" disabled={isSubmitting}>
                        {zoneObj?.id ? "Update" : "Create"}
                    </button>
                </div>
            </Form>
        </CommonModal>
    )
}

export default ZoneInput